import React from 'react';
import { Skeleton } from '../../sectepe-ui/index';

export interface LoadingStateProps {
  /** Anzahl Platzhalterzeilen (Default 4). */
  rows?: number;
  /** Text fuer Screenreader (Default 'Lädt…'). */
  label?: string;
  /** Kleinere Variante fuer Kartenbereiche. */
  compact?: boolean;
}

/** Skeleton-Ladezustand statt eines nackten "Laden..."-Textes. */
export const LoadingState: React.FC<LoadingStateProps> = ({ rows = 4, label = 'Lädt…', compact }) => (
  <div className={`ui-loading${compact ? ' ui-loading--compact' : ''}`} role="status" aria-live="polite" aria-label={label}>
    <span className="sr-only">{label}</span>
    {!compact && <Skeleton variant="text" width="40%" height={28} />}
    {Array.from({ length: rows }).map((_, i) => (
      <Skeleton key={i} variant="text" width={`${90 - (i % 3) * 15}%`} height={16} />
    ))}
  </div>
);

export default LoadingState;
